var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2962_3099)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2962_3099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9958 19.5458L20.1208 4.54583C20.1208 4.54583 20.1125 4.50417 20.1083 4.4875C20.1083 4.47083 20.1 4.45 20.0958 4.43333C20.0875 4.40417 20.075 4.37917 20.0625 4.35417C20.0583 4.34167 20.0541 4.32917 20.0458 4.31667C20.025 4.27917 20 4.24583 19.975 4.2125C19.9625 4.2 19.95 4.19167 19.9375 4.17917C19.9208 4.1625 19.9041 4.14583 19.8833 4.12917C19.8666 4.11667 19.8458 4.10417 19.825 4.09167C19.8083 4.08333 19.7916 4.07083 19.775 4.0625C19.7541 4.05417 19.7333 4.04583 19.7083 4.0375C19.6916 4.02917 19.675 4.025 19.6541 4.02083C19.6333 4.01667 19.6083 4.0125 19.5875 4.00833C19.5666 4.00833 19.5458 4.00417 19.525 4C19.5166 4 19.5083 4 19.5 4H4.49996C4.1833 4 3.9208 4.23333 3.87913 4.54583L2.00413 19.5458C1.9833 19.725 2.03746 19.9042 2.15413 20.0375C2.2708 20.1708 2.44163 20.25 2.6208 20.25H17.625C17.9416 20.25 18.2041 20.0167 18.2458 19.7042L19.5 9.66667L20.7541 19.7042C20.7916 20.0208 21.0625 20.25 21.375 20.25C21.4 20.25 21.425 20.25 21.4541 20.2458C21.7958 20.2042 22.0375 19.8917 21.9958 19.55V19.5458ZM8.3333 19L8.6458 16.5H12.3875L12.075 19H8.3333ZM8.79996 15.25L9.11246 12.75H12.8541L12.5416 15.25H8.79996ZM13.7916 5.25L13.4791 7.75H9.73746L10.05 5.25H13.7916ZM13.325 9L13.0125 11.5H9.2708L9.5833 9H13.325ZM14.5833 9H18.325L18.0125 11.5H14.2708L14.5833 9ZM8.01246 11.5H4.2708L4.5833 9H8.32496L8.01246 11.5ZM4.11663 12.75H7.85413L7.54163 15.25H3.79996L4.11246 12.75H4.11663ZM14.1166 12.75H17.8583L17.5458 15.25H13.8041L14.1166 12.75ZM18.4833 7.75H14.7416L15.0541 5.25H18.7958L18.4833 7.75ZM8.79163 5.25L8.47913 7.75H4.73746L5.04996 5.25H8.79163ZM3.6458 16.5H7.38746L7.07496 19H3.3333L3.6458 16.5ZM13.3333 19L13.6458 16.5H17.3875L17.075 19H13.3333Z",
    fill: "#194142"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2962_3099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2962_3099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.25,
    fill: "white",
    transform: "translate(2 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8fe496929b24d71aa0ab41869b3b2f26.svg";
export { ForwardRef as ReactComponent };